import { NgModule } from '@angular/core';
import { GaMainLayoutModule } from './main-layout/main-layout.module';

const CONTAINERS = [GaMainLayoutModule];

@NgModule({
    imports: [CONTAINERS],
    exports: [CONTAINERS]
})
export class GaShellLayoutsModule { }
